module.exports = __webpack_public_path__ + "img/缩小.7482c9e5.png";